<template>
  <div class="landing-view">
    <Transition name="slide" mode="out-in">
      <!-- VISTA 1: LANDING COMPLETA -->
      <div v-if="!selectedCard && !showTutorForm" key="landing">
        <HeroSection @go="goToSection" :highlight-pills="highlightPills" />
        <section id="official">
          <OfficialSection />
        </section>
        <section id="abc">
          <InfoUsersSection @card-click="handleCardClick" />
        </section>
        <section id="faq">
          <FaqSection />
        </section>
        <section id="menores">
          <TutorsBanner @open-form="handleOpenTutorForm" />
        </section>
        <section id="contacto">
          <TutorsContactSection />
        </section>
        <footer class="site-footer">
          Todos los derechos de propiedad industrial son propiedad de sus respectivos titulares
        </footer>
      </div>
      <!-- VISTA 2: DETALLE DE CARD -->
      <div v-else-if="selectedCard" key="detail">
        <CardDetailView :card="selectedCard" @close="closeDetail" @card-change="handleCardChange" />
      </div>
      <!-- VISTA 3: FORMULARIO DE TUTOR (solo si llegó directo al landing con showTutorForm) -->
      <div v-else-if="showTutorForm" key="tutor">
        <MainStatementAccountView @back="handleTutorBack" />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import HeroSection from '@/components/landing/HeroSection.vue'
import OfficialSection from '@/components/landing/OfficialSection.vue'
import TutorsBanner from '@/components/landing/TutorsBanner.vue'
import InfoUsersSection from '@/components/landing/InfoUsersSection.vue'
import FaqSection from '@/components/landing/FaqSection.vue'
import TutorsContactSection from '@/components/landing/TutorsContactSection.vue'
import CardDetailView from '@/components/landing/CardDetailView.vue'
import MainStatementAccountView from '../baz_statement-account/MainStatementAccountView.vue'

const HIGHLIGHT_DURATION_MS = 1800
const HIGHLIGHT_DELAY_MS = 500
const OPEN_FORM_DELAY_MS = 300

const router = useRouter()
const selectedCard = ref(null)
const highlightPills = ref(false)
const showTutorForm = ref(false)

function goToSection(id) {
  // NOSONAR
  const el = document.getElementById(id) // NOSONAR
  if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }) }
}

function scrollToTop(options = { top: 0, behavior: 'smooth' }) {
  const { scrollTo } = window
  scrollTo(options)
}

function handleOpenTutorForm() {
  selectedCard.value = null
  scrollToTop()
  setTimeout(() => {
    // ✅ Navegar a la ruta del primer paso — URL visible en el navegador
    router.push({ name: 'tutorDatos' })
  }, OPEN_FORM_DELAY_MS)
}

function handleTutorBack() {
  showTutorForm.value = false
  requestAnimationFrame(() => {
    scrollToTop()
    setTimeout(() => {
      highlightPills.value = true
      setTimeout(() => {
        highlightPills.value = false
      }, HIGHLIGHT_DURATION_MS)
    }, HIGHLIGHT_DELAY_MS)
  })
}

function handleCardClick(card) {
  selectedCard.value = { ...card }
  requestAnimationFrame(() => scrollToTop({ top: 0 }))
}

function handleCardChange(card) {
  selectedCard.value = { ...card }
  requestAnimationFrame(() => scrollToTop({ top: 0 }))
}

function closeDetail() {
  selectedCard.value = null
  requestAnimationFrame(() => {
    scrollToTop()
    setTimeout(() => {
      highlightPills.value = true
      setTimeout(() => {
        highlightPills.value = false
      }, HIGHLIGHT_DURATION_MS)
    }, HIGHLIGHT_DELAY_MS)
  })
}
</script>

<style scoped>
.landing-view {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

section {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.site-footer {
  text-align: center;
  padding: 24px 16px;
  font-size: 15px;
  color: #4b4b4b;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .site-footer {
    font-size: 14px;
    padding: 20px 16px;
  }
}

@media (max-width: 600px) {
  .site-footer {
    font-size: 13px;
    padding: 18px 16px;
  }
}

.slide-enter-active {
  transition: opacity 0.6s ease-out, transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);
}

.slide-leave-active {
  transition: opacity 0.3s ease-in, transform 0.4s ease-in;
}

.slide-enter-from {
  opacity: 0;
  transform: scale(0.96);
}

.slide-leave-to {
  opacity: 0;
  transform: scale(1.03);
}
</style>